import { createAction, props } from '@ngrx/store';

export enum ActionType {
    Rate_Search = 'SEARCH RATE',
    Rate_Save = 'SAVE RATE',
    Rate_Add = 'ADD RATE',
    Rate_Copy = 'COPY RATE',
    Rate_Delete = 'DELETE RATE',
    Rate_Edit = 'EDIT RATE',
    None = 'NONE'
}

export interface BaseActionData {
    incentive: boolean;
}
export interface GenericActionData extends BaseActionData {
    facilityId: number;
}
export interface ModifiedRateData extends BaseActionData {
    facilityId: number;
    index: number;
}
export interface SearchData extends BaseActionData {
    searchString: string;
    active?: boolean;
    future?: boolean;
    past?: boolean;
}

export interface ActionInfo {
    actionType: ActionType;
    data: unknown;
}
// reset between different Profile
export const setResetUserAction = createAction(
    '[User Action] Reset User Action',
    props<{ actionType: ActionType; data: GenericActionData }>()
);

// Actions for a Billing Rate
export const setSearchRateUserAction = createAction(
    '[User Action] Search Rate Action',
    props<{ actionType: ActionType; data: SearchData }>()
);

export const setSaveRateUserAction = createAction(
    '[User Action] Save Rate Action',
    props<{ actionType: ActionType; data: GenericActionData }>()
);

export const setAddRateUserAction = createAction(
    '[User Action] Add Rate Action',
    props<{ actionType: ActionType; data: GenericActionData }>()
);

export const setDeleteRateUserAction = createAction(
    '[User Action] Delete Rate Action',
    props<{ actionType: ActionType; data: ModifiedRateData }>()
);

export const setEditRateUserAction = createAction(
    '[User Action] Edit Rate Action',
    props<{ actionType: ActionType; data: ModifiedRateData }>()
);

export const setCopyRatesUserAction = createAction(
    '[User Action] Copy Rates Action',
    props<{ actionType: ActionType; data: GenericActionData }>()
);
